/**
 * D'où vient une ligne du compte, et quel écran la détaille.
 *
 * `origin.kind` est un code du serveur; l'écran n'affiche que ses libellés
 * (domaine `origine_compte`). Un code inconnu ou une pièce sans identifiant
 * renvoie `null`: l'appelant retombe alors sur le détail de l'écriture.
 */
export const routeOrigine = (origine) => {
  if (!origine) return null;
  const { kind, lot_id: lot, settlement_id: decompte, statement_id: etat, contract_id: contrat } = origine;
  switch (kind) {
    case 'LOT_SETTLEMENT':
    case 'LOT_SETTLEMENT_PAYMENT':
      if (lot && decompte) return `/lots/${lot}/decomptes/${decompte}`;
      return lot ? `/lots/${lot}/paiements` : null;
    case 'LOT_ADVANCE':
      return lot ? `/lots/${lot}/paiements` : null;
    case 'TRANSPORT_STATEMENT':
      if (contrat && etat) return `/rentals/inbound/${contrat}/etats/${etat}`;
      return contrat ? `/rentals/inbound/${contrat}` : null;
    case 'RENTAL':
    case 'RENTAL_ADVANCE':
      return contrat ? `/rentals/inbound/${contrat}` : null;
    default:
      return null;
  }
};

/** Référence à montrer pour la pièce: son numéro, sinon celle du lot ou du contrat. */
export const referencePiece = (ligne) =>
  ligne?.reference || ligne?.origin?.lot_reference || ligne?.origin?.contract_reference || '';
